import { render } from "./LegalFooter.vue?vue&type=template&id=8e1af602&scoped=true"
import script from "./LegalFooter.vue?vue&type=script&lang=js"
export * from "./LegalFooter.vue?vue&type=script&lang=js"

import "./LegalFooter.vue?vue&type=style&index=0&id=8e1af602&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8e1af602"]])

export default __exports__